<template>
	<div class="menu-container">
		<transition
			name="bounce"
			@after-enter="animated"
			@after-leave="animated"
			:style="`i:${areaWidthRatio}`"
		>
			<div
				v-show="showMenu"
				id="menu"
				class="menu"
				:style="{
					left: menuX - scaleComp + 'px',
					top: menuY - scaleComp + 'px'
					,
					width: 60 + 'px',
					height: 60 + 'px',
					transform: `scale(${1 * areaWidthRatio})`
				}"
			>
				<div v-if="!showControls">
					<div
						@click.stop="addFlaw"
						class="flaw menu-button"
						:style="{
							height: 20 + 'px',
							width: 20 + 'px',
							left: 20 + 'px',
							top: 20 - 30 * itemScale + 'px'
						}"
					/>
					<div
						@click.stop="noFlaw"
						v-if="comShowOk"
						class="no-flaw menu-button"
						:style="{
							height: 20 + 'px',
							width: 20 + 'px',
							left: 20 + 'px',
							top: 20 + 30 * itemScale + 'px'
						}"
					/>
					<div
						@click.stop="seeInfo"
						v-if="comShowInfo"
						class="info-icon menu-button"
						:style="{
							height: 20 + 'px',
							width: 20 + 'px',
							left: 20 - 30 * itemScale + 'px',
							top: 20 + 'px',						
						}"
					/>
				</div>
				<div v-else>
					<div
						v-for="(groupItem, index) in item.items"
						:key="groupItem.id"
						@mousedown.left.stop="selectItem(groupItem)"
						class="menu-button"
						:class="getItemType(groupItem)"
						:style="{
							height: 20 + 'px',
							width: 20 + 'px',
							left: getX(groupItem, index) + 20 + 'px',
							top: getY(groupItem, index) + 20 + 'px'
						}"
					>
						<div class="circle" :style="getStatus(groupItem)"></div>
					</div>
				</div>
				<div
					v-if="selectedItem.id"
					class="menu-button"
					:class="getItemType(selectedItem)"
					@click="back"
					:style="{
						bottom: 15 + 'px',
						left: 15 + 'px',
						height: 30 + 'px',
						width: 30 + 'px'
					}"
				></div>
				<div
					class="svg-container"
					:style="{
						position: 'absolute',
						height: 100 + 'px',
						width: 100 + 'px',
						left: -20 + 'px',
						top: -20 + 'px'
					}"
				>
					<svg :width="100" :height="100">
						<!-- Menu circle -->
						<circle
							:cx="50"
							:cy="50"
							:r="28 * itemScale || 30"
							stroke="lightgrey"
							:stroke-width="2"
							fill="transparent"
						/>
						<!-- Size buttons -->
						<g
							v-if="showScale"
							:transform="`translate(${44 + 30 * itemScale}, 0)`"
						>
							<circle
								@click="scale(0.1)"
								class="circle-button"
								:cx="2"
								:cy="40"
								:r="7"
								stroke="lightgrey"
								:stroke-width="1"
								fill="white"
							/>
							<circle
								@click="scale(-0.1)"
								class="circle-button"
								:cx="2"
								:cy="60"
								:r="7"
								stroke="lightgrey"
								:stroke-width="1"
								fill="white"
							/>
							<line
								x1="-2"
								y1="40"
								x2="6"
								y2="40"
								style="stroke: black; stroke-width: 1"
							/>
							<line
								x1="2"
								y1="36"
								x2="2"
								y2="44"
								style="stroke: black; stroke-width: 1"
							/>
							<line
								x1="-2"
								y1="60"
								x2="6"
								y2="60"
								style="stroke: black; stroke-width: 1"
							/>
						</g>
						<!-- Close button -->
						<g>
							<circle
								@mousedown.stop="toggleMenu"
								class="circle-button"
								:cx="50"
								:cy="50"
								:r="10"
								stroke="lightgrey"
								:stroke-width="1"
								fill="white"
							/>
							<polygon
								:points="`${45},${45} ${55},${55}`"
								class="cross"
								:style="{ 'stroke-width': 1 }"
							/>
							<polygon
								:points="`${55},${45} ${45},${55}`"
								class="cross"
								:style="{ 'stroke-width': 1 }"
							/>
						</g>
					</svg>
				</div>
			</div>
		</transition>
		<InstructionModal
		v-if="showInfo"
		:item="infoItemTranslated"
		:menuX="menuX"
		:menuY="menuY"
		@cancel="closeInfo"
		/>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import InstructionModal from '../modals/InstructionModal';

export default {
  mixins: [iconMixin],
  model: {
    prop: 'showMenu',
    event: 'menuStatus'
  },
  components: {
    InstructionModal
  },
  props: {
    showMenu: Boolean,
    menuX: Number,
    menuY: Number,
    item: Object,
    zoomLevel: Number,
    showOk: Boolean,
    areaWidthRatio: Number
  },
  data() {
    return {
      rotatePos: 0,
      scalePos: 0,
      scaleComp: 0,
      selectedItem: {},
      infoItem: {},
      showInfo: false
    };
  },
  watch: {
    showMenu(to) {
      if (to) {
        this.setMenuPosition();
      }
    },
    menuX() {
      this.setMenuPosition();
    },
    menuY() {
      this.setMenuPosition();
    },
    item() {
      this.selectedItem = {};
    }
  },
  computed: {
    // re-run translation when locale changes
    _locale() {
      return this.$i18n ? this.$i18n.locale : undefined;
    },

    itemScale() {
      let scale = 1;

      if (this.item && (this.item.inventoryType || this.item.type)) {
        scale = this.item.scale;
      }

      if (this.item && this.item.flawScale) {
        scale = this.item.flawScale;
      }

      return scale < 0.8 ? 0.8 : scale;
    },
    showControls() {
      let hasType = false;

      if (this.item) hasType = this.item.type;

      const isSelected = this.selectedItem.id || false;

      return hasType && !isSelected;
    },
    showScale() {
      return this.item && !this.item.inventoryType && !this.item.type
        ? true
        : false;
    },
    itemLength() {
      return this.item ? this.item.items.length : 0;
    },
    comShowOk() {
      let disable = false;

      if (this.selectedItem.flaws && this.selectedItem.flaws.length) {
        disable = this.selectedItem.flaws[this.selectedItem.flaws.length - 1]
          .done
          ? false
          : true;
      } else if (this.item && this.item.flaws && this.item.flaws.length) {
        disable = this.item.flaws[this.item.flaws.length - 1].done
          ? false
          : true;
      }

      if (this.item && this.item.flawScale) disable = true;

      return this.showOk && !disable;
    },
    comShowInfo() {
      return (this.selectedItem && this.selectedItem.inventoryType)
        || (this.item && this.item.inventoryType);
    },

    displayItemName() {
      this._locale;
      const src = this.selectedItem.id ? this.selectedItem : this.item;
      return this.preferCategoryLabel(src) || src?.name || '';
    },

    infoItemTranslated() {
      this._locale;
      const src = this.infoItem || {};
      const translatedInstruction = this.resolveMaybeI18n(src.instruction);
      const translatedName = this.preferCategoryLabel(src) || src.name || '';
      return { ...src, instruction: translatedInstruction, name: translatedName };
    }
  },
  methods: {
    toggleMenu() {
      this.closeMenu();
    },
    closeMenu() {
      this.selectedItem = {};
      this.$emit('menuStatus', false);
    },
    animated() {
      this.$emit('animated');
    },
    getX(item, index) {
      let r = 28 * this.itemScale || 30;
      const length = this.itemLength;
      let deg = ((2 * Math.PI) / length) * (index + 1) - (2 * Math.PI) / 4;

      return r * Math.cos(deg);
    },
    getY(item, index) {
      let r = 28 * this.itemScale || 30;
      const length = this.itemLength;
      let deg = ((2 * Math.PI) / length) * (index + 1) - (2 * Math.PI) / 4;

      return r * Math.sin(deg);
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    back() {
      this.selectedItem = {};
    },
    addFlaw() {
      if (!this.item) this.$emit('addFlaw');
      else if (this.selectedItem.id) this.$emit('addFlaw', this.selectedItem);
      else this.$emit('addFlaw', this.item);
    },
    noFlaw() {
      if (this.selectedItem.id) {
        this.$emit('noFlaw', this.selectedItem);
        this.back();
      } else {
        this.$emit('noFlaw', this.item);
        this.closeMenu();
      }
    },
    seeInfo() {
      if (this.selectedItem.id) {
        this.infoItem = this.selectedItem;
        this.showInfo = true;
      } else {
        this.infoItem = this.item;
        this.showInfo = true;
      }
    },
    closeInfo() {
      this.showInfo = false;
      this.infoItem = {};
    },
    getStatus(item) {
      const length = item.flaws.length;

      if (item.continueWithoutAdding)
        return 'background: #ff7b0065';

      if (item.controlled) {
        return length > 0 && !item.flaws[length - 1].done
          ? 'background: #ff000065'
          : 'background: #00ff1565';
      }

      if (length > 0 && !item.flaws[length - 1].done)
        return 'background: #ff7b0065';

      return 'background: #0000ff65';
    },
    getItemType(item) {
      let type = '';

      if (!item.id || !item) return;

      if (item.type === 'Grupp') type = item.items[0].inventoryType;

      if (item.inventoryType) type = item.inventoryType;

      return this.getType(type).icon;
    },
    setMenuPosition() {
      let scale = 1;

      if (this.item && this.item.inventoryType) scale = this.item.scale || 1;

      if (this.item && !this.item.inventoryType)
        scale = this.item.flawScale || 1;

      this.scalePos = scale < 0.5 ? 0 : -(scale - 1) * 40;
      this.scaleComp = 30 - 15 * this.areaWidthRatio * scale;
      let deg = 0;

      if (this.item) deg = this.item.rotation;

      deg = deg > 180 ? -(deg - 180) : deg;
      this.rotatePos = deg / 9;
    },
    scale(scale) {
      if (!this.item.flawScale) {
        this.item.flawScale = 1;
      }

      this.item.flawScale = this.item.flawScale + scale;

      if (this.item.flawScale < 0.4) {
        this.item.flawScale = 0.4;
      }

      if (this.item.flawScale > 1.4) {
        this.item.flawScale = 1.4;
      }
    },

    // Translate if it's an i18n key; otherwise return the raw text
    resolveMaybeI18n(val) {
      if (typeof val !== 'string' || !val) return val;
      const raw = val.trim();

      const candidates = [];
      if (raw.startsWith('i18n:')) candidates.push(raw.slice(5));
      candidates.push(raw);
      if (!raw.includes('.') && /^[a-z0-9_]+$/i.test(raw)) {
        candidates.push(`instructions.${raw}`);
      }

      for (const key of candidates) {
        try {
          if (this.$te && this.$te(key)) {
            return this.$t ? this.$t(key) : key;
          }
        } catch (_) {
          // ignore and try the next candidate
        }
      }

      return raw;
    }
  }
};
</script>


<style lang="scss" scoped>
.menu-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}
.menu {
  z-index: 2;
  position: absolute;
  pointer-events: none;
  .circle-button {
    cursor: pointer;
  }
  .menu-button {
    pointer-events: all;
  }
  .cross {
    stroke: black;
    pointer-events: none;
  }
  .svg-container {
    z-index: -1;
    pointer-events: none;
    svg circle.circle-button {
      pointer-events: all;
    }
  }
}
.menu-button {
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  background-size: contain;
  .circle {
    z-index: -1;
    position: absolute;
    width: 150%;
    height: 150%;
    margin-top: -25%;
    margin-left: -25%;
    background: #ff000065;
    border-radius: 100%;
    pointer-events: none;
  }
}
.flaw,
.no-flaw {
  &.menu-button {
    background-color: transparent;
    cursor: pointer;
    z-index: 2;
    position: absolute;
    background-size: contain;
  }
}
</style>
